import { Tooltip } from "@mui/material";
import { FC} from "react";
import { useTranslation } from "react-i18next";
import whiteArrow from "../../../../assets/icons/white_arrow.svg"

interface ArrowButtonProps {
    arrowVwHeight: number;
    arrowVwWidth: number;
    arrowDirection: "horizontal" | "vertical";
    toolTipText: string;
    tipSide: "top" | "right" | "bottom" | "left";
    clickHandler(): void;
    isTheDivShown: boolean;
    disabled?: boolean;
}
const ArrowButton: FC<ArrowButtonProps> = (props) => {
    const { arrowVwHeight, arrowVwWidth, arrowDirection, toolTipText, tipSide, clickHandler, isTheDivShown, disabled } = props;

    const { t } = useTranslation();
    
    const handleClick = () => {
        clickHandler(); 
    }

    const arrowDirectionStyle = { 
        horizontal: "",
        vertical: "rotateFor90Deg"
    }

    const renderArrow = () => {
        return(<img className="white_arrow_show_strength_cards" style={{height: ` ${arrowVwHeight}vw`, width: ` ${arrowVwWidth}vw`}} src={whiteArrow} alt="white arrow" />);
    }

    if (isTheDivShown)
        return (
            <div className={`arrow_button_wrapper opened ${arrowDirectionStyle[arrowDirection]} ${disabled ? "noClick" : ""} `}  onClick={handleClick}>
                <Tooltip title={`${t("toggleText")} ${t(toolTipText)}`} arrow placement="right">
                    {renderArrow()}
                </Tooltip>
            </div>
        );

    return (
        <div className={`arrow_button_wrapper closed ${arrowDirectionStyle[arrowDirection]} ${disabled ? "noClick" : ""} `} onClick={handleClick}>
            <Tooltip title={`${t("toggleText")} ${t(toolTipText)}`} arrow placement={tipSide}>
                {renderArrow()}
            </Tooltip>
        </div>
    );

};
export default ArrowButton;